export default __webpack_public_path__ + "static/authTop-84d09b11c54a71875fd2c2abc49b7671.svg";